/**
 * Formats a name and/or number into a single string.
 *
 * @param {string | null | undefined} [name] - The name to display.
 * @param {string | number | null | undefined} [number] - The number, which might be displayed in parentheses.
 * @returns {string} The formatted string.
 */
export const formatNameNumber = (name?: string | null, number?: string | number | null): string => {
  if (!name) {
    return `${number || ''}`;
  } else if (name === number?.toString()) {
    return name;
  } else {
    return `${name}${number ? ` (${number})` : ''}`;
  }
};

export default formatNameNumber;
